import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f2f5;
`;

export const Section = styled.div`
  padding: 180px;
  background-color: white;
  border: 1px solid rgba(5, 5, 5, 0.06);
  border-radius: 8px;
`;
